import { useSelector, shallowEqual } from "react-redux";

function useUser() {
  return useSelector((state) => {
    if (state.currentUser) {
      return state.currentUser.user;
    } else {
      return null;
    }
  }, shallowEqual);
}

function useMenuActive() {
  return useSelector((state) => {
    if (state.currentUser) {
      return state.currentUser.menuActive;
    } else {
      return null;
    }
  }, shallowEqual);
}

function useUserIsAdmin() {
  return useSelector((state) => {
    if (state.currentUser) {
      return state.currentUser.user.is_admin;
    } else {
      return false;
    }
  }, shallowEqual);
}
export { useUser, useMenuActive, useUserIsAdmin };
